import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../Api";
import { useFlash } from "../context/flashcontext";

export function useProjectForm(onSuccess, onCancel) {
    const { t } = useTranslation();
    const today = new Date().toISOString().split('T')[0];
    const oneWeekLater = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

    const [newProject, setNewProject] = useState({
        name: "",
        location: "",
        address: "",
        client: "",
        contact_person_id: null,
        projectprice: "",
        projectrate: "",
        materialcosts: "",
        start_date: today,
        end_date: oneWeekLater,
        status: "active",
        whatsapp: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { showFlash } = useFlash();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewProject((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        // Convert numeric fields to integers before sending
        const payload = {
            name: newProject.name,
            location: newProject.location,
            address: newProject.address,
            client: newProject.client,
            projectprice: parseInt(newProject.projectprice, 10),
            projectrate: parseInt(newProject.projectrate, 10),
            materialcosts: parseInt(newProject.materialcosts, 10),
            status: newProject.status || "active",
        };

        // Add optional fields if they exist
        if (newProject.whatsapp) {
            payload.whatsapp = newProject.whatsapp;
        }

        if (newProject.contact_person_id) {
            payload.contact_person_id = parseInt(newProject.contact_person_id, 10);
        }

        // Convert dates to ISO format if provided
        if (newProject.start_date) {
            payload.start_date = new Date(newProject.start_date).toISOString();
        }
        if (newProject.end_date) {
            payload.end_date = new Date(newProject.end_date).toISOString();
        }

        try {
            await api.post("/projects", payload);
            showFlash(t('success.projectCreated'), "success");
            if (onSuccess) onSuccess();
        } catch (err) {
            const errorMsg = err?.response?.data?.error || err?.response?.data || t('errors.saveFailed');
            setError(errorMsg);
            showFlash(errorMsg, "error");
        } finally {
            setLoading(false);
        }
    };

    return {
        newProject,
        setNewProject,
        loading,
        error,
        handleInputChange,
        handleSubmit,
        onCancel
    };
}
